import { DataBox } from './DataBox'
import { baseCompanyModel } from '../companyModel'
import { PageHeader } from './PageHeader'
import { AddCompanyModal } from './addCompanyModal'
import { EditCompanyModal } from './editCompanyModal'

export function BaseCompany() {
    const { addCarVisible, editCarVisible } = baseCompanyModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddCompanyModal />}
            {editCarVisible && <EditCompanyModal />}
        </>
    )
}
